<template>
  <div
    id="app"
    class="te-body vh-100"
  >
    <router-view />
    <AwardInformationPopup />
    <Loading v-if="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import AwardInformationPopup from '@/components/activity/AwardInformationPopup.vue';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    AwardInformationPopup,
    Loading,
  },
  computed: {
    ...mapState(['loading', 'companyId']),
  },
  watch: {
    companyId() {
      this.setAxiosRequestInterceptors();
    },
  },
  beforeCreate() {
    sessionStorage.removeItem('_gateteway_t');
  },
  created() {
    if (this.companyId) {
      this.setAxiosRequestInterceptors();
    }

    axios.interceptors.response.use((response) => response, (error) => {
      if (error.config.url === '/sso/post/api/v1/apiauth') {
        this.$router.push({ name: 'Error' });
      }
      throw error;
    });
  },
  methods: {
    setAxiosRequestInterceptors() {
      axios.interceptors.request.use((config) => {
        if (config.url === '/sso/get/api/v1/apiauth') {
          config.url = `${config.url}?companyId=${this.companyId}`;
        }

        if (config.url === '/sso/post/api/v1/apiauth') {
          config.data = JSON.stringify({ companyId: this.companyId });
        }

        return config;
      });
    },
  },
};
</script>

<style>
div.vh-100 {
  height: calc(var(--vh, 1vh) * 100) !important;
}
</style>
